<form class="languages-form" [formGroup]="languageForm" (ngSubmit)="onSubmit()">
  <div class="form-row">
    <div class="form-group">
      <app-select
        id="language"
        formControlName="language"
        [label]="'profile.language.language' | transloco"
        [placeholder]="'profile.language.selectLanguage' | transloco"
        [options]="languageOptions"
        [required]="true"
        [errorMessage]="
          languageForm.get('language')?.invalid && languageForm.get('language')?.touched ?
          (languageForm.get('language')?.errors?.['maxlength'] ?
          ('validation.databaseConstraint.language' | transloco: {max: VALIDATION.LANGUAGE_NAME_MAX_LENGTH}) :
          ('validation.required.language' | transloco)) : ''
        "></app-select>
    </div>
    <div class="form-group">
      <app-select
        id="level"
        formControlName="level"
        [label]="'profile.language.level' | transloco"
        [placeholder]="'profile.language.selectLevel' | transloco"
        [options]="languageLevelOptions"
        [required]="true"
        [errorMessage]="languageForm.get('level')?.invalid && languageForm.get('level')?.touched ? ('validation.required.level' | transloco) : ''"></app-select>
    </div>
  </div>
  <div class="form-actions">
    <app-button type="button" variant="outline" color="secondary" (click)="onCancel()">
      {{ 'button.cancel' | transloco }}
    </app-button>
    <app-button type="submit" variant="filled" [disabled]="languageForm.invalid">
      {{ 'button.save' | transloco }}
    </app-button>
  </div>
</form>
